import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { ENV } from '@shared/config';
import type { ReviewRatings } from '@shared/types';
import { ReviewRatingsQueryKey } from './keys';

export function useGetReviewRatingsQuery({ noteId, enabled = true }: { noteId: string; enabled?: boolean }) {
  return useQuery([ReviewRatingsQueryKey, noteId], async (): Promise<ReviewRatings> => {
    const url = `${ENV.API}/review_ratings/${noteId}`;
    const { data } = await axios.get<{ result_code: number; data: ReviewRatings }>(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
    return data.data;
  }, {
    enabled,
  });
}


